import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
import vailcode from "@utils/errcode";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "forturn",
  computed: {
    forturnNftMenu() {
      const arr = ["Bg yellow", "Bg orange", "Bg pink", "Bg red", "Bg green", "Bg black", "Bg blue"];
      return arr.map(it => {
        return {
          id: -1,
          attr_Bg: it,
          image_url: require("@images/tapcoin/new/fortune/orturn-synthesis-empty.png"),
          nft_count: 0
        };
      });
    }
  },
  data() {
    return {
      popNFTDeficiencyShow: false,
      containerSize: {
        width: 580,
        height: 580
      },
      // 默认值，可被覆盖
      itemSize: {
        width: 0,
        height: 0
      },
      forturnNftList: null,
      isForturnNftListLoading: false,
      forturnList: null,
      forturnListPage: {
        page: 1,
        limit: 50,
        isLoading: false,
        totalPages: 1
      },
      rowForturn: null,
      isBtnGetLoading: false,
      popForturnDetailShow: false,
      forturnDetailNftList: null,
      forturnDetailScore: 0,
      isGcardShow: false,
      gcardScale: 1,
      isBtnTryAgainShow: false,
      isBtnTryAgainLoading: false,
      animationFrame: null
    };
  },
  watch: {
    popForturnDetailShow(bool) {
      if (!bool) {
        this.forturnDetailNftList = null;
      }
    }
  },
  methods: {
    resetCircleItems() {
      const containerSize = this.$refs.circleContainer;
      const width = containerSize.offsetWidth;
      const height = containerSize.offsetHeight;
      const total = this.forturnNftList.length;
      this.containerSize = {
        width,
        height
      };
      const baseRadius = Math.min(width, height) / 2 - 50;
      for (let i = 0; i < total; i++) {
        this.forturnNftList[i].radius = baseRadius;
        this.forturnNftList[i].opacity = 1;
      }
    },
    getCirclePositionStyle(index, total) {
      const containerSize = this.$refs.circleContainer;
      // const { width, height } = containerSize;
      const width = containerSize.offsetWidth;
      const height = containerSize.offsetHeight;
      this.containerSize = {
        width,
        height
      };
      const items = this.$refs.items;
      const itemSize = items.offsetWidth;
      const {
        angle,
        radius,
        opacity,
        scale
      } = this.forturnNftList[index] || {
        angle: 0,
        radius: 0
      };
      const centerX = width / 2;
      const centerY = height / 2;
      console.log("angleangleangleangle", angle, radius);
      // console.log(" angle, radius", angle, radius, itemSize);
      const x = centerX + radius * Math.cos(angle) - itemSize / 2 - 5;
      const y = centerY + radius * Math.sin(angle) - itemSize / 2;
      return {
        position: "absolute",
        left: `${x}px`,
        top: `${y}px`,
        transform: `scale(${scale})`,
        // 可选，仅视觉旋转
        opacity: opacity
      };
    },
    startRotation() {
      return new Promise(resolve => {
        const totalFrames = 120;
        let frame = 0;
        const animate = async () => {
          frame++;
          const progress = frame / totalFrames;
          const easing = t => 1 - Math.pow(1 - t, 3); // easeOutCubic
          const rotateProgress = easing(progress);
          this.gcardScale = 1 + 0.5 * rotateProgress; // 🚀 scale from 1 to 1.5
          for (let i = 0; i < this.forturnNftList.length; i++) {
            const item = this.forturnNftList[i];
            item.angle += 0.1; // 每帧顺时针旋转
            const baseRadius = Math.min(this.containerSize.width, this.containerSize.height) / 2 - 50;
            item.radius = baseRadius * (1 - 0.7 * easing(progress)); // 向中心靠近 30%
            item.opacity -= 0.005;
          }
          if (frame < totalFrames) {
            this.animationFrame = setTimeout(animate, 1000 / 60); // 降帧率
          } else {
            this.forturnNftList.map(it => {
              it.opacity = 0;
            });
            resolve();
          }
        };
        animate();
      });
    },
    shrinkGcardToOne() {
      return new Promise(resolve => {
        const speed = 0.8; // 加速度因子，可调大点更陡峭
        const target = 1;
        const animate = () => {
          const diff = this.gcardScale - target;
          if (Math.abs(diff) < 0.01) {
            this.gcardScale = target; // 精准复原
            console.log(111111111, Math.abs(diff));
            resolve();
            return;
          }
          this.gcardScale -= diff * speed;
          requestAnimationFrame(animate);
        };
        animate();
      });
    },
    async initFnc() {
      await this.getForturnNft();
      await this.getForturnList(1, this.forturnListPage.limit);
    },
    getForturnNft() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/user/fortune/nft", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          const existingBgSet = new Set(data.map(item => item.attr_Bg));
          console.log("existingBgSet", existingBgSet);
          const missingItems = this.forturnNftMenu.filter(item => !existingBgSet.has(item.attr_Bg));
          console.log("missingItems", missingItems);
          const paddedItems = missingItems.map(item => {
            console.log("item111", item);
            return {
              id: -1,
              nft_id: "",
              image_url: item.image_url,
              name: "",
              description: "",
              nft_count: item.nft_count,
              attr_Bg: item.attr_Bg,
              attr_Skin: "",
              attr_Mouth: "",
              attr_Clothing: "",
              attr_Eyes: "",
              attr_Head: "",
              attr_Items: ""
            };
          });

          // arr.push(...paddedItems);
          console.log("paddedItems", paddedItems);
          this.forturnNftList = [];
          let forturnNftList = [];
          forturnNftList.push(...paddedItems, ...data);
          const container = this.$refs.circleContainer;
          if (container) {
            this.containerSize.width = container.offsetWidth;
            this.containerSize.height = container.offsetHeight;
          }
          this.forturnNftList = forturnNftList.map((item, i) => {
            const angle = 2 * Math.PI / forturnNftList.length * i - Math.PI / 2;
            const baseRadius = Math.min(this.containerSize.width, this.containerSize.height) / 2 - 45; // itemSize/2
            return {
              ...item,
              angle,
              opacity: 1,
              radius: baseRadius
            };
          });
          console.log("this.forturnNftList", this.forturnNftList);
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async getForturnList(page = 1, limit = 50) {
      this.forturnListPage.isLoading = true;
      const res = await _v.$http.post("/user/fortune/list", {
        page,
        limit
      });
      return new Promise(resolve => {
        vailcode(res, () => {
          const items = res.data.items || [];
          if (page === 1) {
            this.forturnList = items;
          } else {
            this.forturnList.push(...items);
          }
          this.forturnListPage.totalPages = res.data.lastPage;
          this.forturnListPage.page = page;
          this.forturnListPage.isLoading = false;
          resolve(items);
        }, () => {
          this.forturnListPage.isLoading = false;
          resolve([]);
        });
      });
    },
    getForturnDetail(params) {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/user/fortune/info", params);
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.forturnDetailNftList = data.items;
          this.forturnDetailScore = data.rarity_score || 0;
          console.log("this.forturnDetailNftList", this.forturnDetailNftList);
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    composeForturn() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/user/fortune/compose", {});
        //         const res = {
        //     "code": 0,
        //     "message": "",
        //     "data": {
        //         "id": 41,
        //         "title": "",
        //         "icon": "https://static.tapcoins.app/nft_cats/golden_cat_card.png",
        //         "user_id": 4129783,
        //         "rarity_score": 54323,
        //         "created_at": "2025-07-31T03:44:30.000Z",
        //         "updated_at": null,
        //         "items": [
        //             {
        //                 "id": 412,
        //                 "nft_id": "1000412",
        //                 "image_url": "https://static.tapcoins.app/nft_cats/1000412.png",
        //                 "name": "MetaCats #1000412",
        //                 "description": "MetaCats is more than just collectible NFTs - they're your ticket to unlock missions, events, and perks within the TapCoins universe. Join the squad, earn, evolve, and conquer.",
        //                 "star": 1,
        //                 "rarity_score": 5813,
        //                 "is_use": 1,
        //                 "attributes": {
        //                     "Bg": {
        //                         "value": "Bg green",
        //                         "rarity": 16.144
        //                     },
        //                     "Skin": {
        //                         "value": "Doll",
        //                         "rarity": 3.564
        //                     },
        //                     "Mouth": {
        //                         "value": "Laugh",
        //                         "rarity": 5.286
        //                     },
        //                     "Clothing": {
        //                         "value": "Cardigan",
        //                         "rarity": 3.652
        //                     },
        //                     "Eyes": {
        //                         "value": "Aggravation",
        //                         "rarity": 4.856
        //                     },
        //                     "Head": {
        //                         "value": "Krusty krab hat",
        //                         "rarity": 5.29
        //                     },
        //                     "Items": {
        //                         "value": "Fork with sausage",
        //                         "rarity": 2.844
        //                     }
        //                 }
        //             },
        //             {
        //                 "id": 416,
        //                 "nft_id": "1000416",
        //                 "image_url": "https://static.tapcoins.app/nft_cats/1000416.png",
        //                 "name": "MetaCats #1000416",
        //                 "description": "MetaCats is more than just collectible NFTs - they're your ticket to unlock missions, events, and perks within the TapCoins universe. Join the squad, earn, evolve, and conquer.",
        //                 "star": 1,
        //                 "rarity_score": 11669,
        //                 "is_use": 1,
        //                 "attributes": {
        //                     "Bg": {
        //                         "value": "Bg black",
        //                         "rarity": 16.424
        //                     },
        //                     "Skin": {
        //                         "value": "Peach",
        //                         "rarity": 5.422
        //                     },
        //                     "Mouth": {
        //                         "value": "Sword fangs",
        //                         "rarity": 3.838
        //                     },
        //                     "Clothing": {
        //                         "value": "Hawai shirt",
        //                         "rarity": 3.412
        //                     },
        //                     "Eyes": {
        //                         "value": "Got both eyes tight shut",
        //                         "rarity": 4.948
        //                     },
        //                     "Head": {
        //                         "value": "Chicken",
        //                         "rarity": 2.044
        //                     },
        //                     "Items": {
        //                         "value": "Dental forceps",
        //                         "rarity": 4.384
        //                     }
        //                 }
        //             },
        //             {
        //                 "id": 422,
        //                 "nft_id": "1000422",
        //                 "image_url": "https://static.tapcoins.app/nft_cats/1000422.png",
        //                 "name": "MetaCats #1000422",
        //                 "description": "MetaCats is more than just collectible NFTs - they're your ticket to unlock missions, events, and perks within the TapCoins universe. Join the squad, earn, evolve, and conquer.",
        //                 "star": 1,
        //                 "rarity_score": 9312,
        //                 "is_use": 1,
        //                 "attributes": {
        //                     "Bg": {
        //                         "value": "Bg pink",
        //                         "rarity": 13.872
        //                     },
        //                     "Skin": {
        //                         "value": "Woodem",
        //                         "rarity": 2.292
        //                     },
        //                     "Mouth": {
        //                         "value": "Drool",
        //                         "rarity": 3.09
        //                     },
        //                     "Clothing": {
        //                         "value": "Cowboy",
        //                         "rarity": 5
        //                     },
        //                     "Eyes": {
        //                         "value": "Dilated pupil",
        //                         "rarity": 5.214
        //                     },
        //                     "Head": {
        //                         "value": "Rock",
        //                         "rarity": 7.718
        //                     },
        //                     "Items": {
        //                         "value": "Coffee",
        //                         "rarity": 3.588
        //                     }
        //                 }
        //             },
        //             {
        //                 "id": 428,
        //                 "nft_id": "1000428",
        //                 "image_url": "https://static.tapcoins.app/nft_cats/1000428.png",
        //                 "name": "MetaCats #1000428",
        //                 "description": "MetaCats is more than just collectible NFTs - they're your ticket to unlock missions, events, and perks within the TapCoins universe. Join the squad, earn, evolve, and conquer.",
        //                 "star": 1,
        //                 "rarity_score": 10724,
        //                 "is_use": 1,
        //                 "attributes": {
        //                     "Bg": {
        //                         "value": "Bg orange",
        //                         "rarity": 11.782
        //                     },
        //                     "Skin": {
        //                         "value": "Orange",
        //                         "rarity": 5.502
        //                     },
        //                     "Mouth": {
        //                         "value": "Sausage",
        //                         "rarity": 3.084
        //                     },
        //                     "Clothing": {
        //                         "value": "Sweater",
        //                         "rarity": 2.882
        //                     },
        //                     "Eyes": {
        //                         "value": "Surprise",
        //                         "rarity": 3.242
        //                     },
        //                     "Head": {
        //                         "value": "Bee",
        //                         "rarity": 2.44
        //                     },
        //                     "Items": {
        //                         "value": "Spray lacquer",
        //                         "rarity": 13.51
        //                     }
        //                 }
        //             },
        //             {
        //                 "id": 431,
        //                 "nft_id": "1000431",
        //                 "image_url": "https://static.tapcoins.app/nft_cats/1000431.png",
        //                 "name": "MetaCats #1000431",
        //                 "description": "MetaCats is more than just collectible NFTs - they're your ticket to unlock missions, events, and perks within the TapCoins universe. Join the squad, earn, evolve, and conquer.",
        //                 "star": 1,
        //                 "rarity_score": 6560,
        //                 "is_use": 1,
        //                 "attributes": {
        //                     "Bg": {
        //                         "value": "Bg blue",
        //                         "rarity": 16.146
        //                     },
        //                     "Skin": {
        //                         "value": "Peach",
        //                         "rarity": 5.422
        //                     },
        //                     "Mouth": {
        //                         "value": "Sword fangs",
        //                         "rarity": 3.838
        //                     },
        //                     "Clothing": {
        //                         "value": "Blue shirt",
        //                         "rarity": 2.58
        //                     },
        //                     "Eyes": {
        //                         "value": "Got both eyes tight shut",
        //                         "rarity": 4.948
        //                     },
        //                     "Head": {
        //                         "value": "Headset",
        //                         "rarity": 4.914
        //                     },
        //                     "Items": {
        //                         "value": "Gamepad",
        //                         "rarity": 3.722
        //                     }
        //                 }
        //             },
        //             {
        //                 "id": 456,
        //                 "nft_id": "1000456",
        //                 "image_url": "https://static.tapcoins.app/nft_cats/1000456.png",
        //                 "name": "MetaCats #1000456",
        //                 "description": "MetaCats is more than just collectible NFTs - they're your ticket to unlock missions, events, and perks within the TapCoins universe. Join the squad, earn, evolve, and conquer.",
        //                 "star": 1,
        //                 "rarity_score": 6704,
        //                 "is_use": 1,
        //                 "attributes": {
        //                     "Bg": {
        //                         "value": "Bg yellow",
        //                         "rarity": 11.828
        //                     },
        //                     "Skin": {
        //                         "value": "Brownie",
        //                         "rarity": 5.512
        //                     },
        //                     "Mouth": {
        //                         "value": "Vampire",
        //                         "rarity": 3.976
        //                     },
        //                     "Clothing": {
        //                         "value": "Bikini",
        //                         "rarity": 2.406
        //                     },
        //                     "Eyes": {
        //                         "value": "Hypnotizing",
        //                         "rarity": 3.892
        //                     },
        //                     "Head": {
        //                         "value": "Ufo",
        //                         "rarity": 8.62
        //                     },
        //                     "Items": {
        //                         "value": "Fan",
        //                         "rarity": 7.366
        //                     }
        //                 }
        //             },
        //             {
        //                 "id": 467,
        //                 "nft_id": "1000467",
        //                 "image_url": "https://static.tapcoins.app/nft_cats/1000467.png",
        //                 "name": "MetaCats #1000467",
        //                 "description": "MetaCats is more than just collectible NFTs - they're your ticket to unlock missions, events, and perks within the TapCoins universe. Join the squad, earn, evolve, and conquer.",
        //                 "star": 1,
        //                 "rarity_score": 3541,
        //                 "is_use": 1,
        //                 "attributes": {
        //                     "Bg": {
        //                         "value": "Bg red",
        //                         "rarity": 13.804
        //                     },
        //                     "Skin": {
        //                         "value": "White",
        //                         "rarity": 5.246
        //                     },
        //                     "Mouth": {
        //                         "value": "Lick the mouth",
        //                         "rarity": 5.706
        //                     },
        //                     "Clothing": {
        //                         "value": "Sailor shirt",
        //                         "rarity": 7.796
        //                     },
        //                     "Eyes": {
        //                         "value": "Button",
        //                         "rarity": 2.79
        //                     },
        //                     "Head": {
        //                         "value": "Rock",
        //                         "rarity": 7.718
        //                     },
        //                     "Items": {
        //                         "value": "Fan",
        //                         "rarity": 7.366
        //                     }
        //                 }
        //             }
        //         ]
        //     }
        // }
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          // this.forturnList = data.items;
          resolve(data);
        }, err => {
          console.log(3333333, err);
          resolve();
        });
      });
    },
    async onCompose() {
      const hasInvalidId = this.forturnNftList.some(item => item.id === -1);
      if (hasInvalidId) {
        this.popNFTDeficiencyShow = true;
        return;
      }
      if (this.isBtnGetLoading) return;
      this.isBtnGetLoading = true;
      const res = await this.composeForturn();
      if (!res) {
        this.isBtnGetLoading = false;
        return;
      }
      await this.startRotation();
      clearTimeout(this.animationFrame);
      this.isGcardShow = true;
      await this.shrinkGcardToOne();
      this.$toasted.success("Congratulations on getting Forturn Card");
      this.isBtnGetLoading = false;
      this.isBtnTryAgainShow = true;
      // this.initFnc()
      await this.getForturnList(1, this.forturnListPage.limit);
    },
    async onTryAgain() {
      if (this.isBtnTryAgainLoading) return;
      this.isBtnTryAgainLoading = true;
      const res = await this.getForturnNft();
      this.isGcardShow = false;
      this.isBtnTryAgainShow = false;
      this.isBtnTryAgainLoading = false;
    },
    async onShowForturnDetail(item) {
      this.rowForturn = item;
      this.popForturnDetailShow = true;
      await this.getForturnDetail({
        id: this.rowForturn.id
      });
    },
    setNftItemContainer() {
      this.$nextTick(() => {
        setTimeout(() => {}, 200);
      });
    },
    forturnHandleScroll(e) {
      const el = e.target;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 10 && !this.forturnListPage.isLoading && this.forturnListPage.page < this.forturnListPage.totalPages) {
        this.getForturnList(this.forturnListPage.page + 1, this.forturnListPage.limit);
      }
    },
    onNftDetail(item) {
      const nftDetail = {
        ...item,
        type: null
      };
      this.nftDetail = encodeURIComponent(JSON.stringify(nftDetail));
      this.$nextTick(() => {
        this.$router.push(`/nftdetail?nft=${this.nftDetail}&type=0`);
      });
    }
  },
  mounted() {
    this.$nextTick(async () => {
      window.addEventListener("scroll", this.forturnHandleScroll);
      this.isForturnNftListLoading = false;
      await this.initFnc();
      this.isForturnNftListLoading = true;
    });
  },
  beforeDestroy() {
    console.log(3333222);
    clearTimeout(this.animationFrame);
    window.removeEventListener("scroll", this.myNFTHandleScroll);
  }
};